import { jsx as d } from "react/jsx-runtime";
import { c as h } from "react/compiler-runtime";
import "@mui/material";
import "react";
import "../../../chunks/Map.js";
import "../../../styles/theme.js";
import "@mui/icons-material/InfoOutlined";
import "@mui/icons-material/ArrowDropDown";
import "@mui/icons-material/ArrowDropUp";
import "@mui/icons-material/ArrowLeft";
import "@mui/icons-material/ArrowRight";
import "@mui/icons-material";
import "highcharts-react-official";
import "highcharts";
import "moment-timezone";
import "highcharts/highcharts";
import "../Widgets/WidgetTimelineGraph/WidgetTimelineGraph.styles.js";
import "react-dom/client";
import "react-dom/server";
import "@mui/icons-material/Warning";
import "reactflow";
import "reactflow/dist/style.css";
import "dagre";
import "../NetworkMap/NetworkMapUtils.js";
import "@mui/icons-material/FilterAlt";
import '../../../assets/map.css';import '../../../assets/FilterWrapper.css';/* empty css                            */
import "@mui/material/Menu";
import "@mui/material/FormControl";
import "@mui/material/ListSubheader";
import "lodash";
import "@mui/icons-material/KeyboardArrowDown";
import "@mui/icons-material/Close";
import "@mui/icons-material/Search";
import { Box as b } from "../../atoms/Box/Box.js";
import "../../atoms/Grid/Grid.js";
import { Typography as x } from "../../atoms/Typography/Typography.js";
import "@mui/material/styles";
import "@mui/material/TextField";
import "@mui/material/Fab";
import "@mui/material/TextareaAutosize";
import "@mui/material/InputLabel";
import "@mui/material/CardContent";
import "@mui/material/CardHeader";
import "@mui/material/Collapse";
import "@mui/material/ClickAwayListener";
import "@mui/material/Grow";
import "@mui/material/Fade";
import "@mui/material/Popper";
import "@mui/material/MenuList";
import "@mui/material/Breadcrumbs";
import "@mui/material/Dialog";
import "@mui/material/Modal";
import "@mui/material/FormGroup";
import "@mui/material/Accordion";
import "@mui/material/AccordionSummary";
import "@mui/material/AccordionDetails";
import "@mui/material/Select";
import "@mui/material/Autocomplete";
import "@mui/material/InputAdornment";
import "@mui/material/AlertTitle";
import "@mui/material/ListItemText";
import "@mui/material/List";
import "@mui/material/ListItem";
import "@mui/material/ListItemButton";
import "@mui/material/ListItemAvatar";
import "@mui/material/Backdrop";
import "@mui/material/ListItemIcon";
import "@mui/material/Popover";
import "@mui/material/Drawer";
import "@mui/material/CardMedia";
import "@mui/material/Snackbar";
import "@mui/material/TablePagination";
import "@mui/material/colors";
import "@mui/material/useMediaQuery";
import "@mui/material/OutlinedInput";
import "@mui/icons-material/CheckCircle";
import "@mui/icons-material/RestartAlt";
import "@mui/icons-material/Info";
import "@mui/icons-material/Add";
import "@mui/icons-material/Build";
import "../../../chunks/ChatbotContext.js";
import "react-markdown";
import "remark-gfm";
import "rehype-raw";
import "rehype-sanitize";
import "@mui/icons-material/EventOutlined";
import "@mui/icons-material/KeyboardArrowDownOutlined";
import "@mui/icons-material/CloseRounded";
import "../../organisms/DateTimeSelector/DateTimeSelectorMenu.js";
import "@mui/icons-material/KeyboardDoubleArrowLeftOutlined";
import "@mui/icons-material/KeyboardDoubleArrowRightOutlined";
import "@mui/icons-material/Visibility";
import "@mui/icons-material/VisibilityOff";
import "@mui/icons-material/ArrowForward";
import "../../organisms/RadarGraph/RadarGraph.js";
import "../../organisms/ReactMap/index.js";
import "@mui/material/Button";
import "../../organisms/ReactMap/GMapStatic.js";
import "../../organisms/ReactMap/hooks.js";
import "@mui/icons-material/Clear";
import "../../../chunks/TableContext.js";
import "@tanstack/react-table";
import "@tanstack/react-virtual";
import "@mui/icons-material/FilterAltOff";
import "react-window";
import "../../organisms/Table/TimeRangeFilter.js";
import "@mui/icons-material/KeyboardDoubleArrowLeft";
import "@mui/icons-material/KeyboardDoubleArrowRight";
import "@mui/icons-material/KeyboardArrowLeft";
import "@mui/icons-material/KeyboardArrowRight";
import "@mui/icons-material/ViewWeek";
import "@mui/icons-material/DragIndicator";
import "../../organisms/ScoreGauge/ScoreGauge.js";
import "../../organisms/SunburstGraph/SunburstGraph.js";
import "@mui/icons-material/Menu";
import "../../../fetch/fetchConfig.js";
import "immer";
import "../../atoms/FormControl/FormControl.js";
import "../../atoms/FormControlLabel/FormControlLabel.js";
import "@react-google-maps/api";
import "../../../chunks/index.esm.js";
/* empty css                   */
import "../../atoms/Paper/Paper.js";
import "../../atoms/Radio/Radio.js";
import "../../atoms/RadioGroup/RadioGroup.js";
import "../../atoms/Menu/Menu.js";
import "../../atoms/MenuItem/MenuItem.js";
import "../../atoms/Table/Table.js";
import "../../atoms/TableBody/TableBody.js";
import "../../atoms/TableHead/TableHead.js";
import "../../atoms/TableRow/TableRow.js";
import "../../atoms/TableCell/TableCell.js";
import "../../atoms/ToggleButton/ToggleButton.js";
import "../../atoms/ToggleButtonGroup/ToggleButtonGroup.js";
import "@mui/icons-material/ExpandMore";
import "../../atoms/Stepper/Stepper.js";
import "../../atoms/Step/Step.js";
import "../../atoms/StepLabel/StepLabel.js";
import "../../atoms/Link/Link.js";
import "../../atoms/LoadingButton/LoadingButton.js";
import "../../atoms/LinearProgress/LinearProgress.js";
import "../../atoms/Stack/Stack.js";
import "../../atoms/Card/Card.js";
import "../../atoms/CardActions/CardActions.js";
import "../../atoms/FormHelperText/FormHelperText.js";
import "../../atoms/AccordionDetails/AccordionDetails.js";
import "../../atoms/TableContainer/TableContainer.js";
import "@mui/material/DialogTitle";
import "@mui/material/DialogContent";
import "@mui/material/DialogActions";
import "@mui/material/IconButton";
import "@mui/material/Typography";
function ni(l) {
  const t = h(16);
  let i, r, o, m, e;
  t[0] !== l ? ({
    children: i,
    value: e,
    index: r,
    sx: m,
    ...o
  } = l, t[0] = l, t[1] = i, t[2] = r, t[3] = o, t[4] = m, t[5] = e) : (i = t[1], r = t[2], o = t[3], m = t[4], e = t[5]);
  const a = l.preFetch || !1 ? !0 : e === r, c = e !== r, s = `simple-tabpanel-${r}`, f = `simple-tab-${r}`;
  let p;
  t[6] !== i || t[7] !== a || t[8] !== m ? (p = a && /* @__PURE__ */ d(b, { sx: {
    ...m
  }, children: /* @__PURE__ */ d(x, { children: i }) }), t[6] = i, t[7] = a, t[8] = m, t[9] = p) : p = t[9];
  let n;
  return t[10] !== o || t[11] !== c || t[12] !== s || t[13] !== f || t[14] !== p ? (n = /* @__PURE__ */ d("div", { role: "tabpanel", hidden: c, id: s, "aria-labelledby": f, ...o, children: p }), t[10] = o, t[11] = c, t[12] = s, t[13] = f, t[14] = p, t[15] = n) : n = t[15], n;
}
export {
  ni as TabPanel,
  ni as default
};
